export default ({
  namespaced: true,

  state: {
    headerColor: 'white',
    textColor: 'primary--text'
  },
  
  getters: {
    headerColor: state => state.headerColor,
    textColor: state => state.textColor
  },

  mutations: {
    setHeaderColor(state, color) {
      if (color) {
        switch (color) {
          case 'blue':
            state.headerColor = 'primary'
            state.textColor = 'white--text'
            break;
          case 'white':
            state.headerColor = 'white'
            state.textColor = 'primary--text'
            break;
          default:
            state.headerColor = 'white'
            state.textColor = 'primary--text'
            break;
        }
      }
    },
    defaultHeaderColor(state) {
      state.headerColor = 'white'
      state.textColor = 'primary--text'
    }
  },

  actions: {
    //
  }
})